import React, { useState } from "react";
import { Link, Box, Flex, Image, Text, Button, Stack } from "@chakra-ui/react";
import { TiShoppingCart } from "react-icons/ti";
import { FaShoppingBag } from "react-icons/fa"

function NavBar() {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <NavBarContainer boxShadow='md'>
      <Link href='/'>
        <Image src={`/img/Thelogo.png`} w={100} />
        </Link>
      <NavToggle toggle={toggle} isOpen={isOpen} />
      <NavLinks isOpen={isOpen} />
    </NavBarContainer>
  );
};

// when hamburger icon is being clicked and navigation menu is open
const CloseIcon = () => (
  <svg width="24" viewBox="0 0 18 18" fill="black">
    <path
      d="M9.00023 7.58599L13.9502 2.63599L15.3642 4.04999L10.4142 8.99999L15.3642 13.95L13.9502 15.364L9.00023 10.414L4.05023 15.364L2.63623 13.95L7.58623 8.99999L2.63623 4.04999L4.05023 2.63599L9.00023 7.58599Z"
    />
  </svg>
);

// hamburger icon
const HamburgerIcon = () => (
  <svg
    width="24px"
    viewBox="0 0 20 20"
    fill="black"
  >
    <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
  </svg>
);

// nav toggle between hambuger menu icon and the close icon
const NavToggle = ({ toggle, isOpen }) => {
  return (
    <Box display={{ base: "block", md: "none" }} onClick={toggle}>
      {isOpen ? <CloseIcon /> : <HamburgerIcon />}
    </Box>
  );
};

// items for navigation
const NavItem = ({ children, isLast, to = "/", ...rest }) => {
  return (
    <Link href={to}>
      <Text display="block" {...rest}>
        {children}
      </Text>
    </Link>
  );
};

// directs for the navigation links
const NavLinks = ({ isOpen }) => {
  const theToken = localStorage.getItem('token');
  const theUserDetails = JSON.parse(localStorage.getItem('userDetails'));
  return (
    <Box
      display={{ base: isOpen ? "block" : "none", md: "block" }}
      flexBasis={{ base: "100%", md: "auto" }}
    >
      <Stack
        spacing={10}
        align="center"
        justify={["center", "space-between", "flex-end", "flex-end"]}
        direction={["column", "row", "row", "row"]}
        pt={[8, 8, 0, 0]}
      >
        <NavItem 
          to="/"
          textDecoration= 'none'
          fontWeight = {700}
          color = '#383838'
          _hover = {{
            color: 'black',
            transition: 'color .35s ease-in-out',
            textDecoration: 'none'
          }}
        >
          Home
        </NavItem>
        <NavItem 
          to="/products"
          fontWeight = {700}
          color = '#3b3b3b'
          _hover = {{
            color: 'black',
            transition: 'color .35s ease-in-out'
          }}
        >
          Our Products
        </NavItem>
        {
          theUserDetails === null ? 
          <NavItem to={`/login`} _hover={{transition: "transform 1s ease-in-out", transform: "scale3d(1.2, 1.2, 1)"}}><TiShoppingCart size={32}/></NavItem> : 
          <NavItem to={`/user/${theUserDetails.userid}/carts`} _hover={{transition: "transform 1s ease-in-out", transform: "scale3d(1.2, 1.2, 1)"}}><TiShoppingCart size={32}/></NavItem>
          }
        {/* Change the routing for the below 1 screen later on */}
        <NavItem to="/orders" _hover={{transition: "transform 1s ease-in-out", transform: "scale3d(1.2, 1.2, 1)"}}><FaShoppingBag size={26}/></NavItem>
        {
          theToken == null ? 
          <NavItem to="/login">
            <Button
              size="md"
              rounded="md"
              color='white'
              bg={["black", "black", "primary.500", "primary.500"]}
              _hover={{
                border: "1px solid black",
                background: "white",
                color: "black"
              }}
            >
              Login
            </Button>
          </NavItem> :
          <NavItem to={`/user/${theUserDetails.userid}/profile`}>
            <Button
              size="md"
              rounded="md"
              color='white'
              border = '2px solid black'
              bg={["black", "black", "primary.500", "primary.500"]}
              _hover={{
                border: "2px solid black",
                background: "white",
                color: "black"
              }}
            >
              Profile
            </Button>
          </NavItem>
        }
      </Stack>
    </Box>
  );
};

const NavBarContainer = ({ children, ...props }) => {
  return (
    <Flex
      align="center"
      justify="space-between"
      wrap="wrap"
      w="100%"
      p={6}
      px={12}
      bg={["primary.500", "primary.500", "transparent", "transparent"]}
      color={["black", "black", "primary.700", "primary.700"]}
      {...props}
    >
      {children}
    </Flex>
  );
};

export default NavBar;
